import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import CreateDepartmentRole from './CreateDepartmentRole';
import GroupSelector from './GroupSelector';
import CreateTeamRole from './CreateTeamRole';

export default function CreateGroupRole(props: {
	user: graphql.User;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	refetch: () => Promise<any>;
	onCancel: () => void;
	onCreate: () => void;
}) {
	const { t } = useTranslation();

	const [group, setGroup] = useState<graphql.Group>();

	return group ? (
		group.type === graphql.GroupType.Department ? (
			<CreateDepartmentRole
				source={props.user}
				target={group}
				refetch={props.refetch}
				onCancel={props.onCancel}
				onCreate={props.onCreate}
			/>
		) : (
			<CreateTeamRole
				source={props.user}
				target={group}
				refetch={props.refetch}
				onCancel={props.onCancel}
				onCreate={props.onCreate}
			/>
		)
	) : (
		<GroupSelector
			placeholder={t('settings.employees.roles.create.group.placeholder', {
				name: props.user.firstName,
			})}
			onChange={(group) => setGroup(group as graphql.Group)}
		/>
	);
}
